import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/layouts/Layout";
import Home from "@/pages/Home";
import ClientsPage from "@/pages/ClientsPage";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminOverview from "@/pages/admin/AdminOverview";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import ClientsAdmin from "@/pages/admin/ClientsAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import ContactsAdmin from "@/pages/admin/ContactsAdmin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/clients" element={<ClientsPage />} />
            </Route>

            {/* Admin auth */}
            <Route path="/admin/login" element={<Login />} />

            {/* Admin protected */}
            <Route
              path="/admin"
              element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}
            >
              <Route index element={<AdminOverview />} />
              <Route path="products" element={<ProductsAdmin />} />
              <Route path="clients" element={<ClientsAdmin />} />
              <Route path="testimonials" element={<TestimonialsAdmin />} />
              <Route path="contacts" element={<ContactsAdmin />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
